document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  // Animate section heading
  gsap.from(".purpose-heading", {
    scrollTrigger: {
      trigger: ".purpose-section",
      start: "top 80%",   // when section enters viewport
      toggleActions: "play none none none"
    },
    y: 50,
    opacity: 0,
    duration: 1,
    ease: "power3.out"
  });

  // Animate cards (left & right stagger)
  gsap.utils.toArray(".purpose-card").forEach((card, i) => {
    gsap.from(card, {
      scrollTrigger: {
        trigger: card,
        start: "top 85%",
        toggleActions: "play none none none"
      },
      x: i % 2 === 0 ? -100 : 100, // alternate left/right
      opacity: 0,
      duration: 1,
      ease: "power2.out"
    });
  });
});
